// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

// Utils
import { stopPropagationOnly } from '../../../utils/domUtil';
import { isIconViewLike } from '../../../../common/elements/utils/elementDisplayUtils';

// Selectors
import { activePopupSelector } from '../../../components/popupPanel/popupOpenSelector';
import { getGridSize } from '../../../utils/grid/gridSizeSelector';

// Actions
import { closePopup } from '../../../components/popupPanel/popupActions';

// Components
import PopupPanelMouseManager from '../../../components/popupPanel/PopupPanelMouseManager';
import ElementCloneInstancesPopupContent from './ElementCloneInstancesPopupContent';
import FloatingPanel from '../../../components/tooltips/FloatingPanel';

// Constants
import { TooltipPositions } from '../../../components/tooltips/tooltipConstants';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './ElementCloneInstancesPopup.scss';

const ElementCloneInstancesPopup = (props: {
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
    popupId: string;
    elementId: string;
    element: ImMNElement;
}) => {
    const { className, popupId, element } = props;

    const dispatch = useDispatch();
    const dispatchClosePopup = (popupId: string) => dispatch(closePopup(popupId, false));

    const activePopups = useSelector(activePopupSelector);
    const isPopupOpen = activePopups.has(popupId);
    const gridSize = useSelector(getGridSize);
    const position = isIconViewLike(element) ? TooltipPositions.TOP : TooltipPositions.BOTTOM;

    if (!isPopupOpen) return null;

    const closeThisPopup = () => dispatchClosePopup(popupId);

    return (
        <FloatingPanel
            selector={`.popup-trigger-${popupId}`}
            className={classNames('ElementCloneInstancesPopup', className, 'light')}
            arrowColor="var(--ui-modal-background-primary)"
            arrowStrokeColor="var(--ui-background-primary)"
            arrowWidth={13}
            arrowHeight={8}
            arrowStrokeWidth={0}
            distance={10}
            offset={0}
            position={position}
            gridSize={gridSize}
            responsive
            pollPosition
        >
            <PopupPanelMouseManager {...props} visible={isPopupOpen} popupId={popupId} closePopup={closeThisPopup}>
                <div className="popup-content" onClick={stopPropagationOnly}>
                    <ElementCloneInstancesPopupContent {...props} />
                </div>
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default ElementCloneInstancesPopup;
